import {
    get,
    post,
    _delete,
    put,
  } from '../axios'
  
  class VisitPlan {
    async getVisitPlanDetail(param) {
      const res = await get('/VisitPlan/GetVisitPlanDetail', param)
      return res
    }
    async delVisitPlan(param) {
      const res = await _delete('/VisitPlan/DelVisitPlan', param)
      return res
    }
    async addVisitPlan(data,param) {
      const res = await post('/VisitPlan/AddVisitPlan',data,param)
      return res
    }
    async updateVisitPlan(data,param) {
      const res = await put('/VisitPlan/UpdateVisitPlan',data,param)
      return res
    }
    async getVisitPlanPageList(param) {
      const res = await get('/VisitPlan/GetVisitPlanPageList',param)
      return res
    }

  }
  export default new VisitPlan()